export default __webpack_public_path__ + "static/media/bg-shape.752db224.png";